module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_0.f7f073ec.png";